/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterXSmall = createReactComponent("outline", "letter-x-small", "IconLetterXSmall", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }]]);

export { IconLetterXSmall as default };
//# sourceMappingURL=IconLetterXSmall.mjs.map
